import React from "react";
import {Modal, ModalBody, ModalHeader} from "reactstrap";
import {useGetData} from "./useGetData";
import CustomFieldDisplayTable from "./customFieldDisplayTable";

const CustomFieldDisplay = (props) => {
  const {objectId, objectType, open, onToggle} = props;
  const {customFields} = useGetData(objectType, objectId);
  return (
    <Modal isOpen={open} toggle={onToggle} size="lg">
      <ModalHeader toggle={onToggle}>Custom Fields</ModalHeader>
      <ModalBody>
        <CustomFieldDisplayTable data={customFields} />
      </ModalBody>
    </Modal>
  );
};

export default CustomFieldDisplay;
